import apiEndpoints from "../endpoints";
import apiClient from "../exportClient";

// Login credentials interface
interface LoginCredentials {
  email: string;
  password: string;
}

// Magic link request interface
interface MagicLinkRequest {
  email: string;
}

// Magic link verification interface
interface MagicLinkVerification {
  token_key: string;
}

// New magic link request interface
interface NewMagicLinkRequest {
  token: string;
}

// Backend sends 'forgotPassaword' - keep endpoint name as-is for compatibility
const authApis = () => {
  return {
    getProfile: {
      queryKey: ["get-user-profile"],
      queryFn: () => {
        return apiClient.get(apiEndpoints.auth.getProfile);
      },
    },
    login: {
      mutationKey: ["login"],
      mutationFn: async (credentials: LoginCredentials) => {
        return apiClient.post(apiEndpoints.auth.login, credentials);
      },
    },
    magicLinkRequest: {
      mutationKey: ["magic-link-request"],
      mutationFn: async (data: MagicLinkRequest) => {
        return apiClient.post(apiEndpoints.auth.magicLinkRequest, data);
      },
    },
    magicLinkVerify: {
      mutationKey: ["magic-link-verify"],
      mutationFn: async (data: MagicLinkVerification) => {
        return apiClient.post(apiEndpoints.auth.magicLinkVerify, data);
      },
    },
    newMagicLink: {
      mutationKey: ["new-magic-link"],
      mutationFn: async (data: NewMagicLinkRequest) => {
        return apiClient.post(apiEndpoints.auth.newMagicLink, data);
      },
    },
  };
};

export default authApis;
